export default __webpack_public_path__ + "static/media/signin-background-two.04d852c9.jpg";